<template>
  <div class="onlineClass home_page">
    <div class="category_list" v-show="!choosedId">
      <!-- 级别类目 -->
      <el-row class="category_row">
        <el-col :span="3" class="row_lable">按专题</el-col>
        <el-col :span="19">
          <el-row v-for="(ele, idx) in Math.ceil(categoryList.length/8)" :key="idx"
                  v-show="showMoreCategory || (idx == 0)">
            <el-col :span="3"
                    class="ellipsis category-item"
                    v-for="(item) in categoryList.slice(idx * 8, idx * 8 + 8)"
                    :key="item.id"
                    v-show="showMoreCategory ||(idx == 0)">
              <span class="ellipsis cursor-pointer item_span"
                    @click="choosedCategory(item.id)"
                    :class="{'item_select':item.id === choosedId}"
                    :title="item.videoTypeName">
                {{item.videoTypeName}}
              </span>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="2" class="category-more" v-show="categoryList.length > 8">
          <div class="more-button cursor-pointer" @click.stop="showMoreCategory = !showMoreCategory">
            {{!showMoreCategory ? '更多' : '收起'}}
            <i :class="showMoreCategory ? 'el-icon-arrow-up' :' el-icon-arrow-down'"></i>
          </div>
        </el-col>
      </el-row>
      <!-- 培训条件 -->
      <div>
        <!-- 一级类目 -->
        <el-row class="category_row">
          <el-col :span="3" class="row_lable">按专业</el-col>
          <el-col :span="2" class="ellipsis category-item">
            <span class="ellipsis cursor-pointer item_span"
                  @click="choosedOneClassCategory('')"
                  :class="{'item_select':!choosedClassCateIdList[0]}"
                  title="全部">
              全部
            </span>
          </el-col>
          <el-col :span="19">
            <el-row v-for="(ele, idx) in Math.ceil(categoryClass.length/9)"
                    :key="idx">
              <el-col :span="3"
                      class="ellipsis category-item"
                      v-for="(item) in categoryClass.slice(idx * 8, idx * 8 + 8)"
                      :key="item.id">
                <span class="ellipsis cursor-pointer item_span"
                      @click="choosedOneClassCategory(item.id)"
                      :class="{'item_select':item.id === choosedClassCateIdList[0]}"
                      :title="item.typeName">
                  {{item.typeName}}
                </span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <!-- 二级类目 -->
        <el-row class="category_row" v-show="getClassTwoCateList.length">
          <el-col :span="3" class="row_lable">&nbsp;</el-col>
          <el-col :span="2" class="ellipsis category-item">
            &nbsp;
          </el-col>
          <el-col :span="19">
            <el-row v-for="(ele, idx) in Math.ceil(getClassTwoCateList.length/9)"
                    :key="idx">
              <el-col :span="3"
                      class="ellipsis category-item"
                      v-for="(item) in getClassTwoCateList.slice(idx * 8, idx * 8 + 8)"
                      :key="item.id">
                <span class="ellipsis cursor-pointer item_span"
                      @click="choosedTwoClassCategory(item.id)"
                      :class="{'item_select':item.id === choosedClassCateIdList[1]}"
                      :title="item.typeName">
                  {{item.typeName}}
                </span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <!-- 按老师 -->
        <el-row class="category_row">
          <!--  v-show="teacherList.length" -->
          <el-col :span="3" class="row_lable">按讲师</el-col>
          <el-col :span="2" class="ellipsis category-item">
            <span class="ellipsis cursor-pointer item_span"
                  @click="choosedTeacher('')"
                  :class="{'item_select':!calssForm.teacherId}"
                  title="全部">
              全部
            </span>
          </el-col>
          <el-col :span="19">
            <el-row v-for="(ele, idx) in Math.ceil(teacherList.length/12)"
                    :key="idx">
              <el-col :span="2"
                      class="ellipsis category-item"
                      v-for="(item) in teacherList.slice(idx * 12, idx * 12 + 12)"
                      :key="item.id">
                <span class="ellipsis cursor-pointer item_span"
                      @click="choosedTeacher(item.id)"
                      :class="{'item_select':item.id === calssForm.teacherId}"
                      :title="item.name">
                  {{item.name}}
                </span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <!-- 按供应商 -->
        <el-row class="category_row">
          <!--  v-show="resourceCodeList.length" -->
          <el-col :span="3" class="row_lable">按供应商</el-col>
          <el-col :span="2" class="ellipsis category-item">
            <span class="ellipsis cursor-pointer item_span"
                  @click="choosedSupplier('')"
                  :class="{'item_select':!calssForm.resourceCode}"
                  title="全部">
              全部
            </span>
          </el-col>
          <el-col :span="19">
            <el-row v-for="(ele, idx) in Math.ceil(resourceCodeList.length/9)"
                    :key="idx">
              <el-col :span="3"
                      class="ellipsis category-item"
                      v-for="(item) in resourceCodeList.slice(idx * 8, idx * 8 + 8)"
                      :key="item.resourceCode">
                <span class="ellipsis cursor-pointer item_span"
                      @click="choosedSupplier(item.resourceCode)"
                      :class="{'item_select':item.resourceCode === calssForm.resourceCode}"
                      :title="item.resourceName">
                  {{item.resourceName}}
                </span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <!-- 按收费 -->
        <el-row class="category_row">
          <el-col :span="3" class="row_lable">按收费</el-col>
          <!-- <el-col :span="2" class="ellipsis category-item">
            <span class="ellipsis cursor-pointer item_span"
                  @click="choosedSupplier('')"
                  :class="{'item_select':!calssForm.resourceCode}"
                  title="全部">
              全部
            </span>
          </el-col> -->
          <el-col :span="21">
            <el-row>
              <el-col :span="2"
                      class="ellipsis category-item">
                <span class="ellipsis cursor-pointer item_span"
                      @click="choosedFree(true)"
                      :class="{'item_select':true === calssForm.free}"
                      title="免费">
                  免费
                </span>
              </el-col>
              <el-col :span="2"
                      class="ellipsis category-item">
                <span class="ellipsis cursor-pointer item_span"
                      @click="choosedFree(false)"
                      :class="{'item_select':false === calssForm.free}"
                      title="收费">
                  收费
                </span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <!-- 排序 -->
        <div class="sort">
          <ul>
            <li :class="{'checked': calssForm.orderType===1}"
                class="cursor-pointer"
                @click="changeOrderType(1)">
              关注度
            </li>
            <li :class="{'checked': calssForm.orderType===2}"
                class="cursor-pointer"
                @click="changeOrderType(2)">
              最新
            </li>
            <li :class="{'checked': calssForm.orderType===3 || calssForm.orderType===4}"
                class="cursor-pointer"
                @click="changeOrderType(3)">
              价格
              <div class="sort_status">
                <i class="el-icon-caret-top"
                   v-show="calssForm.orderType !== 3"
                   :class="{'sort_status_selected': calssForm.orderType === 4}"></i>
                <i class="el-icon-caret-bottom"
                   v-show="calssForm.orderType !== 4"
                   :class="{'sort_status_selected': calssForm.orderType === 3}"></i>
              </div>
            </li>
          </ul>
        </div>
        <!-- 培训课程列表 -->
        <CourserList :courseList="dataList"
                   :page="dataForm.page"
                   :total="dataForm.total"
                   v-show="!choosedId"
                   @changePage="getCourseList"
        >
        </CourserList>
      </div>
      <!-- 知识视频 -->
      <!-- <div v-show="choosedId">
        二级类目
        <el-row class="category_row" v-show="getVideoTwoCateList.length">
          <el-col :span="3" class="row_lable">&nbsp;</el-col>
          <el-col :span="2" class="ellipsis category-item">
            &nbsp;
          </el-col>
          <el-col :span="19">
            <el-row v-for="(ele, idx) in Math.ceil(getVideoTwoCateList.length/8)"
                    :key="idx">
              <el-col :span="3"
                      class="ellipsis category-item"
                      v-for="(item) in getVideoTwoCateList.slice(idx * 8, idx * 8 + 8)"
                      :key="item.id">
                <span class="ellipsis cursor-pointer item_span"
                      @click="choosedTwoVideoCategory(item.id)"
                      :class="{'item_select':item.id === choosedVideoCateIds[1]}"
                      :title="item.videoTypeName">
                  {{item.videoTypeName}}
                </span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
         二级类目
        <el-row class="category_row" v-show="getVideoThreeCateList.length">
          <el-col :span="3" class="row_lable">&nbsp;</el-col>
          <el-col :span="2" class="ellipsis category-item">
            &nbsp;
          </el-col>
          <el-col :span="19">
            <el-row v-for="(ele, idx) in Math.ceil(getVideoThreeCateList.length/8)"
                    :key="idx">
              <el-col :span="3"
                      class="ellipsis category-item"
                      v-for="(item) in getVideoThreeCateList.slice(idx * 8, idx * 8 + 8)"
                      :key="item.id">
                <span class="ellipsis cursor-pointer item_span"
                      @click="choosedThreeVideoCategory(item.id)"
                      :class="{'item_select':item.id === choosedVideoCateIds[2]}"
                      :title="item.videoTypeName">
                  {{item.videoTypeName}}
                </span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div> -->
    </div>
    <KnowledgeVideoList v-show="choosedId"
                        @choosedCategory="choosedCategory"
                        :choosedId="choosedId"
    ></KnowledgeVideoList>
  </div>
</template>
<script>
import CourserList from './common/courserList'
import KnowledgeVideoList from '../trainManagement/course/knowledgeVideoList'
export default {
  name: 'onlineClass', // 在线课堂列表
  data () {
    return {
      categoryList: [],
      showMoreCategory: false, // 一级类目是否显示所有
      choosedId: '', // 当前选中得类目
      // 课程专业
      categoryClass: [], // 课程类目列表树
      teacherList: [], // 教师列表
      resourceCodeList: [], // 供应商列表
      choosedClassCateIdList: [''], // 课程选中的类目id
      calssForm: {
        teacherId: '', // 选中的讲师
        resourceCode: '', // 选中供应商
        orderType: 1, // 1关注度 2最新 3价格 降序 4价格 升序
        free: null
      },
      // 知识视频
      choosedVideoCateIds: [],
      // g
      dataForm: {
        page: 1,
        limit: 16,
        total: 0
      },
      dataList: []
    }
  },
  mounted () {
    this.getKnowledgeCategory()
    this.getClassCategory()
    if (!this.choosedId) {
      this.getCourseList()
    } else {}
  },
  components: {
    CourserList,
    KnowledgeVideoList
  },
  computed: {
    // 获取选中的课程一级类目下的二级列表
    getClassTwoCateList () {
      let list = []
      if (this.choosedClassCateIdList[0]) {
        let choosed = this.categoryClass.find(item => {
          return item.id === this.choosedClassCateIdList[0]
        })
        if (choosed) {
          list = choosed.child || []
        }
      }
      return list
    },
    // 获取选中的视频一级类目下的二级列表
    getVideoTwoCateList () {
      let list = []
      if (this.choosedVideoCateIds[0]) {
        let choosed = this.categoryList.find(item => {
          return item.id === this.choosedVideoCateIds[0]
        })
        if (choosed) {
          list = choosed.children || []
        }
      }
      return list
    },
    // 获取选中的视频二级类目下的三级列表
    getVideoThreeCateList () {
      let list = []
      if (this.choosedVideoCateIds[1]) {
        let choosed = this.getVideoTwoCateList.find(item => {
          // console.log(item.id, )
          return item.id === this.choosedVideoCateIds[1]
        })
        if (choosed) {
          list = choosed.children || []
        }
      }
      return list
    }
  },
  methods: {
    // 获取知识社区类目
    getKnowledgeCategory () {
      let list = [{
        id: '',
        videoTypeName: '培训课程'
      }]
      this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/kc/technicalvideo/technicalvideotype/variableVideoLevel`)
        .then(({ data }) => {
          if (data.code === 0 && data.data && data.data.length) {
            list.push(...data.data)
          }
          this.categoryList = list
        })
    },
    // 获取培训课程类目
    getClassCategory () {
      let categoryClass = []
      let teacherList = []
      let resourceCodeList = []
      this.$http.get(`/front/train/trainCourse/categoryNavigation`)
        .then(({ data }) => {
          if (data.code === 0) {
            categoryClass = data.data.typeTree || []
            teacherList = data.data.teacherEntityList || []
            resourceCodeList = data.data.resourceCodeList || []
            // if (Array.isArray(data.data.typeTree)) {
            //   categoryClass.push(...data.data.typeTree)
            // }
            // if (Array.isArray(data.data.teacherEntityList)) {
            //   teacherList.push(...data.data.teacherEntityList)
            // }
          }
          this.categoryClass = categoryClass
          this.teacherList = teacherList
          this.resourceCodeList = resourceCodeList
        })
    },
    // 选择一级类目
    choosedCategory (id) {
      if (id) {
        this.dataForm.page = 1
        // 选择知识社区
        this.choosedVideoCateIds = [id]
        this.getVideoList(1)
      } else {
        // 选择培训
        this.choosedClassCateIdList = ['']
        this.calssForm.teacherId = ''
        this.calssForm.resourceCode = ''
        this.calssForm.orderType = 1
        this.calssForm.free = null
        this.getCourseList(1)
      }
      this.choosedId = id
    },
    // 选中课程一级类目
    choosedOneClassCategory (id) {
      this.$set(this.choosedClassCateIdList, 0, id)
      this.getCourseList(1)
    },
    // 选中课程二级类目
    choosedTwoClassCategory (id) {
      this.$set(this.choosedClassCateIdList, 1, id)
      this.getCourseList(1)
    },
    // 选中讲师id
    choosedTeacher (id) {
      this.calssForm.teacherId = id
      this.getCourseList(1)
    },
    // 选择供应商
    choosedSupplier (id) {
      this.calssForm.resourceCode = id
      this.getCourseList(1)
    },
    // 收费免费
    choosedFree (val) {
      // 与陈江确认此处 双击取消选中
      if (val === this.calssForm.free) {
        this.calssForm.free = null
      } else {
        this.calssForm.free = val
      }
      this.getCourseList(1)
    },
    // 更改排序
    changeOrderType (val) {
      if (val === 3 && this.calssForm.orderType === 3) {
        this.calssForm.orderType = 4
      } else {
        if (val === this.calssForm.orderType || (this.calssForm.orderType === 4 && val === 3)) {
          this.calssForm.orderType = 1
        } else {
          this.calssForm.orderType = val
        }
      }
      this.getCourseList(1)
    },
    // 获取课程列表
    getCourseList (page = this.dataForm.page) {
      this.dataForm.page = page
      let cateId = null
      if (this.choosedClassCateIdList[0]) {
        if (this.choosedClassCateIdList[1]) {
          cateId = this.choosedClassCateIdList[1] || null
        } else {
          cateId = this.choosedClassCateIdList[0] || null
        }
      }
      this.$http.post(`/front/train/trainCourse/selectHomeAllTrainCourseList`, {
        // 一级分类或二级分类
        type: cateId,
        ...this.dataForm, // 分页相关信息
        ...this.calssForm
      }).then(({ data }) => {
        if (data.code === 0) {
          this.dataList = data.data.data || []
          this.dataForm.total = Number(data.data.count) || 0
        //   this.setPageTo(currentPage)
        } else {
          this.dataList = []
          this.dataForm.total = 0
        }
      }).catch(() => {
        this.dataList = []
        this.dataForm.total = 0
      })
    },
    // 知识社区
    // 选中知识社区二级类目
    choosedTwoVideoCategory (id) {
      this.choosedVideoCateIds = [this.choosedVideoCateIds[0], id]
      this.getVideoList(1)
    },
    // 选中知识社区三级级类目
    choosedThreeVideoCategory (id) {
      this.choosedVideoCateIds = [
        this.choosedVideoCateIds[0],
        this.choosedVideoCateIds[1],
        id
      ]
      this.getVideoList(1)
    },
    // 获取视频列表
    getVideoList (page = this.dataForm.page) {
      this.dataForm.page = page
    }
  }
}
</script>
<style lang='scss' scoped>
.onlineClass{
  .category_list{
    .category_row{
      background: #fff;
      border-top: 1px solid #dedede;
      display: flex;
      line-height: 40px;
      font-size: 14px;
      color: #333333;
      letter-spacing: 0;
      text-align: center;
      .row_lable{
        padding-left: 10px;
        background: #f2f2f2;
        color: #333333;
        overflow: hidden;
      }
      .choosed_category_item{
        display: flex;
        align-items: center;
        height: 30px;
      }
      // 已选中的类目展示
      .category_next{
        margin-left: 5px;
      }
      .choosed_category{
        border: 1px solid #2e88ff;
        margin-left: 5px;
        display: flex;
        height: 20px;
        line-height: 20px;
        // align-items: center;
        .choosed_category_name{
          padding: 0px 10px;
          line-height: 18px
        }
        .category_close{
          background: #2e88ff;
          color: #fff;
          line-height: 20px;
          cursor: pointer;
        }
      }
      .category-item{
        text-align: center;
        // display: flex;
        align-items: center;
        min-height: 30px;
        .item_span{
          padding: 0px 5px;
          max-width: 100%;
          float: left;
          margin: 0 auto;
          width: 100%;
        }
        .item_select{
          color: #0064c0;
          font-weight: 400;
        }
      }
      .category-more{
        text-align: right;
        padding-right: 5px;
        .more-button{
          text-align: center;
          background: #ffffff;
          border: 1px solid #e6e6e6;
          // line-height: 20px;
          // margin: 5px;
          padding: 5px 10px;
          display: inline;
          color: #999999;
          font-weight: 400;
          font-size: 14px;
        }
      }
    }
    .sort{
      // width: 97px;
      line-height: 40px;
      margin: 10px 0;
      background: #fff;
      ul{
        display: flex;
        li{
          padding: 0 30px;
          line-height: 40px;
          border-right: 2px solid #eee;
          color: #1d65a8;
          display: flex;
          .sort_status{
            font-size: 10px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: #bebebe;
            .sort_status_selected{
              color: #fff;
            }
          }
        }
        .checked{
          background-color: #1d65a8;
          color: #fff
        }
      }
    }
  }
}
</style>
